export const Acti_SET_ACTIVITY = 'SET_ACTIVITY'
export const Acti_SET_ACTION_TYPES = 'SET_ACTION_TYPES'
export const Acti_SET_CURRENT_ACTION = 'SET_CURRENT_ACTION'
export const Acti_CANCEL_REPORT = 'CANCEL_REPORT'
export const Acti_SET_STORE = 'SET_STORE'
export const Acti_SET_FORM = 'SET_FORM'
export const Acti_SET_CAMERA_FAILED = 'SET_CAMERA_FAILED'
export const Acti_SET_DISPLAY_UNITS = 'SET_DISPLAY_UNITS'
export const Acti_SET_TARGET_UNIT_TYPE = 'SET_TARGET_UNIT_TYPE'
export const Acti_SET_SECTIONS = 'SET_SECTIONS'
export const Acti_SET_UNIT_FORM_UNIT_ID = 'SET_UNIT_FORM_UNIT_ID'
export const Acti_SET_FORM_TEMPLATE = 'SET_FORM_TEMPLATE'
export const Acti_READY_ADD_UNITS = 'READY_ADD_UNITS'
export const Acti_SELECT_ALL_BY_TYPE = 'SELECT_ALL_BY_TYPE'
